import { MultichainActionType } from '@popup/multichain/actions/action-type.enum';
import { MessageType } from 'src/reference-data/message-type.enum';
export const setErrorMessage = (key, params = []) => {
    return {
        type: MultichainActionType.SET_MESSAGE,
        payload: { key, type: MessageType.ERROR, params },
    };
};
export const setSuccessMessage = (key, params = []) => {
    return {
        type: MultichainActionType.SET_MESSAGE,
        payload: { key, type: MessageType.SUCCESS, params },
    };
};
export const setInfoMessage = (key, params = []) => {
    return {
        type: MultichainActionType.SET_MESSAGE,
        payload: { key, type: MessageType.INFO, params },
    };
};
export const setWarningMessage = (key, params = []) => {
    return {
        type: MultichainActionType.SET_MESSAGE,
        payload: { key, type: MessageType.WARNING, params },
    };
};
export const resetMessage = () => {
    return {
        type: MultichainActionType.SET_MESSAGE,
        payload: { key: '', type: MessageType.SUCCESS, params: [] },
    };
};
